<script>
  import Seo from "$lib/components/SEO.svelte";
  import { setContext } from "svelte";
  import FreeformPageTemplate from "$lib/pageTemplates/FreeformPageTemplate.svelte";

  export let data;
  const contributors = data.contributorsData;
  setContext("contributors", contributors);
</script>

<Seo
  data={data.pageEntry.fields.pageData.fields}
  currentUrl={data.currentUrl}
  cookieBanner={data.cookieBanner}
/>

<FreeformPageTemplate page={data.pageEntry} />
